import React from 'react';
import About from '../About';
import Blog from '../Blog';
import Contact from '../Contact';
import Home from '../Home';
import Skills from '../Skills';
import Work from '../Work';

const MyCompo = () => {
    return (
        <div>
            <Home></Home>
            <About></About>
            <Skills></Skills>
            <Work></Work>
            <Blog></Blog>
            <Contact></Contact>
        </div>
    );
};

export default MyCompo;